import styled from "styled-components"
import styleWithOrgDesign from "QuorumGrassroots/styled-components/connect"

export const Banner = styleWithOrgDesign(styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    width: 100%;
    padding: 1rem 1.25rem;

    /* GOTV brand requirement: use fixed banner blue for now; when color variables are available, we can switch back to organization-based colors. */
    background: #223d81;
    color: white;

    border-radius: 12px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }
`)

export const IconWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    width: 40px;
    height: 40px;
    border-radius: 8px;

    background: rgba(255, 255, 255, 0.2);
    color: white;

    i {
        font-size: 18px;
        line-height: 1;
    }
`

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    flex: 1 1 auto;

    .name {
        font-family: "Roboto", sans-serif;
        font-size: 16px; /* Use px to avoid 10px rem-base shrinking text */
        font-weight: 700;
        line-height: 1.2;
        color: #ffffff;
    }

    .date {
        font-family: "Roboto", sans-serif;
        font-size: 14px; /* Use px to ensure 14px under 10px rem base */
        font-weight: 500;
        line-height: 1.2;
        color: rgba(255, 255, 255, 0.85);
    }
`

export const Actions = styled.div`
    display: flex;
    align-items: center;
    gap: var(--plum-spacing-xs);

    button {
        background-color: var(--organization-primary-color-5);

        span,
        i,
        svg {
            color: var(--plum-white);
        }

        &:hover {
            background-color: var(--organization-primary-color-7) !important;
            border-color: var(--organization-primary-color-9) !important;
        }

        &:focus {
            box-shadow: 0 0 0 1px solid var(--plum-black) !important;
            outline: 1px solid var(--plum-black) !important;
            border-color: var(--plum-black) !important;
            outline-offset: 2px !important;
            background-color: var(--organization-primary-color-7) !important;
        }
    }

    @media (max-width: 768px) {
        width: 100%;
        justify-content: stretch;
    }
`

export const GhostButton = styled.button`
    appearance: none;
    border: 1px solid rgba(255, 255, 255, 0.7);
    background: transparent;
    color: white;
    border-radius: 8px;
    padding: 0.5rem 0.75rem;
    font-size: 14px; /* Match button text to 14px explicitly */
    font-weight: 600;
    line-height: 1;
    cursor: default; /* Non-functional placeholder per NEO-6398 */

    display: inline-flex;
    align-items: center;
    gap: 0.5rem;

    i {
        font-size: 14px;
    }

    @media (max-width: 768px) {
        flex: 1 1 0;
        justify-content: center;
    }
`
